<div class="referrals" *ngIf="(referralState$|async) as state">

  <nav aria-label="breadcrumb">
    <div class="pull-right mr-4">
      <div class='commission mt-2'>
        <strong>COMMISSION:</strong>
        <span class='text-success'>
          <div class="spinner-border text-primary" role="status" *ngIf="state.loaders.commission">
            <span class="sr-only">Loading...</span>
          </div>
          {{state.commissionRate|currency:'UGX'}}
        </span>
        <span><button type="button" class="btn btn-link" data-toggle="modal" [disabled]='state.loaders.commission'
            data-target="#commissionModal"><strong>Change</strong></button></span>
      </div>
    </div>
    <ol class="breadcrumb mr-auto">
      <li class="breadcrumb-item" aria-current="page">Usage</li>
      <li class="breadcrumb-item active"><a routerLink="/usage/referrals">Referrals</a></li>
      <li class="breadcrumb-item active"><a [routerLink]='"/usage/referrals/"+id'>{{id}}</a></li>
    </ol>
  </nav>
  <hr>
  <app-commision-modal [commisionRate]='(commissionRate$|async)' (updateCommission)='OnUpdateCommission($event)'>
  </app-commision-modal>
  <router-outlet></router-outlet>
</div>
